import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { DisabledDetailsState, TERMS_AND_PRIVACY_POLICY_LINKS } from '@platform-frontend/account';
import { differenceInDays } from 'date-fns';
import { MatomoTracker } from 'ngx-matomo-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-reactivate-account-ui',
  templateUrl: './reactivate-account-ui.component.html',
  styleUrls: ['./reactivate-account-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class ReactivateAccountUiComponent implements OnInit {
  constructor(private store: Store, private matomoTracker: MatomoTracker) {}

  @Output()
  cancelMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  reactivateMethod: EventEmitter<void> = new EventEmitter();

  deleteDate$: Observable<Date | null> = this.store.select(DisabledDetailsState.deleteDate);
  days$: Observable<number>;

  readonly TERMS_AND_PRIVACY_POLICY = TERMS_AND_PRIVACY_POLICY_LINKS;
  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;

  ngOnInit(): void {
    this.days$ = this.deleteDate$.pipe(map(date => this.calculateDays(date)));
  }

  cancel(): void {
    this.cancelMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_ACCOUNT, 'ReactivateAccount', 'Cancel');
  }

  reactivate(): void {
    this.reactivateMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_ACCOUNT, 'ReactivateAccount', 'ReactivateAccount');
  }

  private calculateDays(endDate: Date | null): number {
    return endDate ? differenceInDays(endDate, Date.now()) : 0;
  }
}
